import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'
import { flatRateTaxes } from 'modules/contracts/lib/germanContractData'

interface Props {
  flatRateTaxId?: number | null
}

const FlatRateTax = ({ flatRateTaxId }: Props) => {
  const flatRateTax = flatRateTaxId ? flatRateTaxes()[flatRateTaxId] : undefined

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.germany.flat_rate_tax')}
      description={flatRateTax}
    />
  )
}

export default observer(FlatRateTax)
